<template>
	<div class="checkout">
    <base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
      :buttons="banner.buttons"
		>
		</base-banner>

    <base-goto :breadcrumbs="breadcrumbs"></base-goto>

    <div id="content">
      <div id="checkout" class="sec">
        <v-container id="billing">
          <!-- <v-row id="promo" data-aos="fade-up">
            <v-col cols="12" sm="12" md="8" lg="8" xl="8">
              <v-card
                rounded="lg"
                flat
                class="lg-card"
                width="100%"
              >
                <div class="display-1 font-weight-black">Enter promo code:</div>
                <v-text-field
                  label="Promo Code"
                  hide-details=""
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row> -->

          <v-row data-aos="fade-up">
            <v-col cols="12" sm="12" md="8" lg="8" xl="8">
              <v-card
                rounded="lg"
                flat
                class="lg-card"
              >
                <div class="display-1 font-weight-black">Billing Information</div>
                <v-form ref="billingForm">
                <v-row>
                  <!-- Country -->
                  <v-col
                    class="pb-0"
                    cols="12" sm="12" md="8" lg="8" xl="8"
                  >
                    <v-select
                      ref="country"
                      v-model="country"
                      :rules="[() => !!country || 'This field is required']"
                      :error-messages="errorMessages"
                      label="Country*"
                      :items="countries"
                      item-text="name"
                      item-value="code"
                    ></v-select>
                  </v-col>

                  <!-- No. of Dependents -->
                  <v-col
                    class="pb-0"
                    cols="12" sm="12" md="4" lg="4" xl="4"
                  >
                    <v-select
                      v-if="maxDependents > 1"
                      ref="dependents"
                      v-model="dependents"
                      :rules="[() => dependents >= 0 && dependents !== null || 'This field is required']"
                      :error-messages="errorMessages"
                      :items="dependentItems"
                      label="No. of Dependents*"
                    ></v-select>
                  </v-col>

                  <!-- First Name -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="first_name"
                      v-model="firstName"
                      :rules="[() => !!firstName || 'This field is required']"
                      :error-messages="errorMessages"
                      label="First Name*"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- Last Name -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="last_name"
                      v-model="lastName"
                      :rules="[() => !!lastName || 'This field is required']"
                      :error-messages="errorMessages"
                      label="Last Name*"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- Middle Name -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="middle_name"
                      v-model="middleName"
                      label="Middle Name"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- Address 1 -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="address1"
                      v-model="address1"
                      :rules="[() => !!address1 || 'This field is required']"
                      :error-messages="errorMessages"
                      label="Address 1*"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- Address 2 -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="address2"
                      v-model="address2"
                      label="Address 2"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- City -->
                  <v-col
                    cols="12" sm="12" md="4" lg="4" xl="4"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="city"
                      v-model="city"
                      :rules="[() => !!city || 'This field is required']"
                      :error-messages="errorMessages"
                      label="City*"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- State -->
                  <v-col
                    cols="12" sm="12" md="4" lg="4" xl="4"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="state"
                      v-model="state"
                      :rules="[() => !!state || 'This field is required']"
                      :error-messages="errorMessages"
                      label="State*"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- Zip Code -->
                  <v-col
                    cols="12" sm="12" md="4" lg="4" xl="4"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="zip_code"
                      v-model="zipCode"
                      :rules="[() => !!zipCode || 'This field is required']"
                      :error-messages="errorMessages"
                      label="Zip Code*"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- Phone number -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="phone_number"
                      v-model="phoneNumber"
                      :rules="[() => !!phoneNumber || 'This field is required']"
                      :error-messages="errorMessages"
                      label="Phone number*"
                      type="text"
                    ></v-text-field>
                  </v-col>

                  <!-- Email address -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      ref="email"
                      v-model="email"
                      :rules="[() => !!email || 'This field is required',
                               () => /.+@.+\..+/.test(email) || 'Email must be valid']"
                      :error-messages="errorMessages"
                      label="Email address*"
                      type="email"
                    ></v-text-field>
                  </v-col>

                  <!-- Confirm email address -->
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                  >
                    <v-text-field
                      v-model="confirm"
                      :rules="[() => !!confirm || 'This field is required',
                               () => confirm == email  || 'Email does not match']"
                      :error-messages="errorMessages"
                      label="Confirm email address*"
                      type="email"
                    ></v-text-field>
                  </v-col>

                  <!-- Birthday -->
                  <v-col
                    class="pt-0 pb-0"
                    cols="12" sm="12" md="6" lg="6" xl="6"
                  >
                    <v-menu
                      v-model="birthdateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          placeholder="M/D/YYYY"
                          :rules="[() => !!birthdate || 'This field is required']"
                          v-model="birthdateFormat"
                          label="Birthday*"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="birthdate"
                        ref="birthdate"
                        :error-messages="errorMessages"
                        no-title
                        @input="birthdateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <!-- Source of information -->
                  <v-col
                    class="pt-0 pb-0"
                    cols="12" sm="12" md="6" lg="6" xl="6"
                  >
                    <v-select
                      ref="source"
                      v-model="source"
                      :items="sources"
                      label="Source of Information"
                    ></v-select>
                  </v-col>

                  <!-- Sex -->
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-radio-group
                      row
                      label="Sex"
                      v-model="sex"
                      :rules="[() => !!sex || 'This field is required']"
                    >
                      <v-radio
                        label="Male"
                        value="male"
                      ></v-radio>
                      <v-radio
                        label="Female"
                        value="female"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>

                  <!-- Agree -->
                  <v-col cols="12">
                    <v-checkbox
                      v-model="agree"
                      light
                      class="mt-1 mb-1"
                      :rules="[() => !!agree || 'You must agree to continue']"
                    >
                      <template slot="label">
                        <div slot='label' class="black--text">I agree with the <a @click.stop href="/terms-and-conditions/medgate-shop">Terms &amp; Conditions</a></div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <!-- Buy more -->
                  <!-- <v-col cols="12" sm="12" md="5" lg="5" xl="5">
                    <router-link to="/shop">
                      <v-btn text color="#1d87fd">
                        <v-icon color="#40ecb8">mdi-chevron-right</v-icon>
                        I want to buy more!
                      </v-btn>
                    </router-link>
                  </v-col> -->

                  <!-- Submit button -->
                  <v-row justify="center">
                    <base-button
                      name="Get My Plan Now!"
                      color="#0e6ccd"
                      @click="confirmBillingInfo()"
                      icon="mdi-arrow-right"
                      x-large
                      :disabled="cartProduct.quantity <= 0"
                    ></base-button>
                  </v-row>
                </v-row>
                </v-form>
              </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="py-0">
              <v-row>
                <!-- Summary -->
                <v-col cols="12">
                  <v-card
                    rounded="lg"
                    flat
                    class="sm-card mx-0 px-0"
                    width="100%"
                  >
                    <!-- Cart has items -->
                    <div v-if="cartProduct.quantity > 0" class="summary">
                      <v-row class="mx-0">
                        <!-- Summary card title -->
                        <v-col cols="12">
                          <div class="display-1 font-weight-black px-5">Summary</div>
                        </v-col>

                        <!-- Summary items -->
                        <v-col cols="12">
                          <div>
                            <summary-item-row
                              :name="cartProduct.name"
                              :amount="cartProduct.amount"
                              :quantity="cartProduct.quantity"
                              :description="cartProduct.description"
                              :member="cartProduct.member"
                            ></summary-item-row>
                            <!-- <discount-row
                              v-if="promoCodeInfo"
                              :name="promoCodeInfo.name"
                              :discount="promoCodeInfo.discount"
                            ></discount-row> -->
                          </div>
                        </v-col>
                      </v-row>

                      <div class="grey my-3" style="height: 1px;"></div>

                      <v-row class="mx-0 pl-3 pr-5">
                        <!-- <v-col cols="7">
                          <span
                            :class="[details?'accent--text':'', 'text-hover font-weight-bold']"
                            @click="details = !details"
                          >
                            <v-icon color="#40ecb8">{{ details ? 'mdi-chevron-up' : 'mdi-chevron-right' }}</v-icon>
                            See more details
                          </span>
                        </v-col> -->
                        <v-col cols="12" class="text-right">
                          <span class="text-right black--text">
                            <span class="font-weight-bold mr-3">Total: </span>
                            {{ total | numFormat('0,0.00') }}
                          </span>
                        </v-col>
                      </v-row>

                      <v-row class="px-7">
                        <v-col cols="12">
                          <cart-summary-details
                            v-if="details"
                            :name="cartProduct.name"
                            :amount="cartProduct.amount"
                            :quantity="cartProduct.quantity"
                            :description="cartProduct.description"
                            :discount="cartProduct.discount"
                            :total="total"
                            :member="cartProduct.member"
                          ></cart-summary-details>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Cart is empty -->
                    <v-row
                      v-else
                      justify="center"
                      align="center"
                      class="fill-height"
                    >
                      <div class="text-center">
                        <v-icon x-large>mdi-cart-off</v-icon>
                        <p class="text-center grey--text pt-3">You cart is empty</p>
                      </div>
                    </v-row>
                  </v-card>
                </v-col>

                <!-- Partners -->
                <v-col cols="12">
                  <v-card
                    rounded="lg"
                    flat
                    class="sm-card"
                  >
                    <h2 class="font-weight-black">Online Payment partners</h2>
                    <v-img src="@/assets/images/partners/payment_partners.png"></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <bill-confirm-dialog
      v-model="confirmDialog"
      :country="country"
      :firstName="firstName"
      :middleName="middleName"
      :lastName="lastName"
      :address1="address1"
      :city="city"
      :state="state"
      :zipCode="zipCode"
      :phoneNumber="phoneNumber"
      :email="email"
      :source="source"
      :dependents="dependents"
    >
      <base-button
        slot="confirm-button"
        x-large
        class="my-4 mx-auto"
        icon="mdi-arrow-right"
        name="Confirm and get my plan now!"
        color="#0e6ccd"
        @click="confirmCheckout()"
      ></base-button>
    </bill-confirm-dialog>

    <bill-success-dialog v-model="successDialog">
    </bill-success-dialog>

    <!-- HIDDEN FOR TO REDIRECT TO PAYNAMICS PAYMENT GATEWAY -->
    <v-form v-show="false" method="POST" :action="paynamics.postRedirect">
      <button type="submit" name="paymentrequest" :value="paynamics.paymentRequest" ref="redirectWebPaymentFinal">Submit</button>
    </v-form>
  </div>
</template>

<script>
import BillConfirmDialog from "@/components/shop/BillConfirmDialog.vue";
import BillSuccessDialog from "@/components/shop/BillSuccessDialog.vue";
import SummaryItemRow from "@/components/shop/SummaryItemRow.vue";
import CartSummaryDetails from "@/components/shop/CartSummaryDetails.vue";
import countries from "@/assets/countries.js";

import Repository from "@/api/repositories";
const ShopCheckoutBannersApi = Repository.get("shopCheckoutBanners");
const BillingDetailsApi = Repository.get("shopMerchantBillingDetails");
const ShopMerchantsApi = Repository.get("shopMerchants");

export default {
  name: "ShopMerchantCheckout",
  components: {
    BillConfirmDialog,
    BillSuccessDialog,
    SummaryItemRow,
    CartSummaryDetails
  },
  data() {
    return {
      details: true,
      birthdateMenu: false,
      birthdateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
			merchantSlugStorage: localStorage.merchantSlug,
      merchantIdStorage: localStorage.merchantId,
      banner: [],
      /* form fields */
      country: null,
      dependents: null,
      firstName: null,
      lastName: null,
      middleName: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      zipCode: null,
      phoneNumber: null,
      email: null,
      birthdate: null,
      sex: null,
      source: null,
      /* form fields */
      confirm: null,
      agree: false,
      errorMessages: '',
      countries: countries,
      confirmDialog: false,
      successDialog: false,
      sources: [
        "Colleague",
        "Company",
        "Medgate Employee",
        "Newsletter",
        "Search Engine",
        "Social Media"
      ],
      breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
				{
					name: "Shop",
					link: "/shop",
					active: false
        },
        {
					name: "Billing Information Merchant",
					link: "/shop/promo/checkout/merchant-slug",
					active: true
        }
			],
      paynamics: {}
		}
  },
  computed: {
    maxDependents() { return this.cartProduct.maxDependents },
    dependentItems() {
      let items = []
      for(let i = 1; i <= this.maxDependents; i++){
        items.push(i);
      }
      return items;
    },
    birthdateFormat () {
      return this.formatDate(this.birthdate)
    },
    billingForm() {
      return {
        country: this.country,
        no_dependents: this.dependents,
        first_name: this.firstName,
        last_name: this.lastName,
        middle_name: this.middleName,
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        state: this.state,
        zip_code: this.zipCode,
        phone_number: this.phoneNumber,
        email: this.email,
        birthdate: this.birthdate,
        sex: this.sex,
        source: this.source,
        products: [
          this.billingCartProduct
        ],
        reseller_id: localStorage.merchantId
      }
    },
    cartProduct: function() {
      // if url slug is different form the saved merchant slug
      if (this.merchantSlugStorage !== this.$route.params.slug) {
        return false
      }
      else {
        var item = this.$store.getters['merchantCart/item'];

        return {
          shop_plan_id: item.id,
          quantity: item.quantity || 0,
          discount: item.discount,
          amount: item.price,
          name: item.name,
          description: item.description,
          member: item.member,
          maxDependents: item.maxDependents
        }
      }
    },
    billingCartProduct: function() {
      var item = this.$store.getters['merchantCart/item'];
      var planQuantity = item.quantity || 0
      var dividedTotal = (this.totalCost+item.discount)/planQuantity

      return {
        shop_plan_id: item.id,
        quantity: planQuantity,
        discount: item.discount,
        amount: dividedTotal,
        name: item.name,
        description: item.description,
        member: item.member
      }
    },
    total: function() {
      var total = this.$store.getters['merchantCart/total']
      return (this.cartProduct.discount)
        ? total - this.cartProduct.discount
        : total
    },
    subtotal() {
      return this.total+this.memberTotal;
    },
    memberQuantity() {
      return this.$store.getters['merchantCart/memberQuantity']
    },
    memberTotal() {
      let quantity = this.memberQuantity
      var amount = this.$store.getters['merchantCart/member']
        
      return quantity*amount;
    },
    vatAmount() {
      return this.subtotal*0.12
    },
    totalCost() {
      return this.subtotal+this.vatAmount
    }
  },
  async created() {
    await this.autheticateUrl();
  },
  mounted() {
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    async autheticateUrl() {
      console.log(this.$route.params.slug)
      try {
        const { data } = await ShopMerchantsApi.get();
        let merchants = data.data;

        var slugIndex = merchants.findIndex(item => 
          item.slug == this.$route.params.slug
        );
        
        // if url slug is NOT registered in database
        if (slugIndex < 0) {
          // then REDIRECT to "enter merchant code" page
          this.$router.push({ name: 'NotFound' })
        }

        // if url slug is REGISTERED
        else {
          await this.getCheckoutBanner();
          this.setHeaderColor();

          let merchantOtherDetails = merchants[slugIndex].other_details;

          if (merchantOtherDetails && merchantOtherDetails.sources) {
            this.sources = merchantOtherDetails.sources
          }
        }
        
        // if url slug is REGISTERED
        // else {
          // but user visited the page WTIHOUT code input
          // or url slug id is DIFFERENT from the saved localStorage merchant id
          // if (!this.merchantIdStorage || merchants[slugIndex].id != this.merchantIdStorage) {
            // then REDIRECT to "enter merchant code" page
            // this.$router.push({ name: 'ShopMerchantCode' })
          // }
          // else {
          //   await this.getCheckoutBanner();
          //   this.setHeaderColor();
          // }
        // }
        
        console.log('[shop-merchants]', merchants);
      }
      catch(error) {
        console.log(error);
      }
    },
    setHeaderColor() {
      console.log('header-color', this.banner)
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getCheckoutBanner() {
      try {
        const { data } = await ShopCheckoutBannersApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          // exclude "enter promo code" button
          var sortedButtons = apiData.buttons.filter(button => button.redirect !== '#promo')
          let buttons = sortedButtons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }

        console.log('[shop-checkout-banner]', data, this.banner);
      }
      catch(error) {
        console.log(error);
      }
    },
    async confirmCheckout() {
      this.confirmDialog = false;

      try {
        if (localStorage.merchantId) {
          this.applyCartDiscount();

          var save = await BillingDetailsApi.create(this.billingForm);
        }

        if (save) {
          // this.successDialog = true;

          let {
            data : {
              data : item
            }
          } = save;

          this.paynamics = {
            postRedirect: item.paynamics.post_redirect,
            paymentRequest: item.paynamics.payment_request
          }

          this.$store.commit('merchantCart/deleteItem');

          setTimeout(() => {
            this.$refs.redirectWebPaymentFinal.click();
          }, 500);
          
        }
        else {
          console.log("Sorry, there was a problem saving your transaction.");
        }
      }
      catch(error) {
        console.log(error);
      }
    },
    confirmBillingInfo() {
      if (this.$refs.billingForm.validate()) this.confirmDialog = true;
    },
    applyCartDiscount() {
      /**
       * apply discount if product dont have preset discount
       */
      if (this.cartProduct.discount) {
        return;
      }

      // if (this.promoCodeInfo) {
      //   this.cartProduct.discount = this.promoCodeInfo.discount;
      //   return;
      // }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

// #header {
//   height: 700px;
//   background: url("~@/assets/images/banners/banner_01.jpg") 50% 18% / cover;
// }

#checkout {
  background: $gray2;

  .lg-card, .sm-card {
    div, h2 {
      color: $blue;
    }
  }

  .lg-card {
    padding: 70px;
  }

  .sm-card {
    padding: 30px;
  }

  .summary {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>